module.exports = __webpack_public_path__ + "img/photo_top_bg.d99f119a.jpg";